import { useState, useEffect } from 'react';
import { AWS_CONFIG } from '../config/aws';
import { isYoutubeUrl } from './youtube';

// Single config row for the home/footer YouTube channel link.
// Convention (no backend change): category 'youtube-channel', sortOrder 1,
// imageUrl = channel URL, alt = 'on' | 'off' (visibility toggle).
export const YOUTUBE_CHANNEL_CATEGORY = 'youtube-channel';
export const YOUTUBE_CHANNEL_SORT = 1;

// Returns { url, enabled, loaded }. enabled is true only when a valid channel URL
// is saved AND the admin toggled it on.
export function useYoutubeChannel() {
  const [state, setState] = useState({ url: '', enabled: false, loaded: false });
  useEffect(() => {
    fetch(`${AWS_CONFIG.apiUrl}/images?category=${YOUTUBE_CHANNEL_CATEGORY}`)
      .then(r => r.json())
      .then(data => {
        const item = (data.images || [])[0];
        const url = item?.imageUrl || '';
        const enabled = !!url && isYoutubeUrl(url) && item?.alt === 'on';
        setState({ url, enabled, loaded: true });
      })
      .catch(() => setState(s => ({ ...s, loaded: true })));
  }, []);
  return state;
}
